export enum PPRegulationTypes {
    UK = '2',
    Spain = '4',
    Denmark = '5',
    Sweden = '6',
    Malta = '8',
    Portugal = '10',
    German = '11',
    SZ_Switzerland = '12',
    Netherlands = '15'
}
